module.exports = __webpack_public_path__ + "static/media/logo-novaolinda.01a9956d.png";